import { useTranslation } from 'react-i18next';
import { StyledPayoutListHeader } from './styles';
import { ReactComponent as ArrowDownIcon } from 'assets/icons/arrow-down-full.svg';
import { TSortPayoutByHeaderTitle } from 'types';
interface IPayoutListHeaderProps {
  children?: React.ReactNode;
  onSort: (sortBy: TSortPayoutByHeaderTitle) => void;
  sortBy: string | null;
  sortDir: 'ASC' | 'DESC' | 'NONE';
}
export const PayoutListHeader = ({ onSort, sortBy, sortDir }: IPayoutListHeaderProps) => {
  const { t } = useTranslation();
  return (
    <StyledPayoutListHeader>
      <div className="payouts-list-header-element id">
        <div>{t('payoutPage.payoutsList.header.id')}</div>
        <button
          className="sort-by-button"
          onClick={() => onSort('id')}
          style={{
            opacity: sortBy === 'id' && sortDir !== 'NONE' ? 1 : 0.6,
            transform: `scale(${sortBy === 'id' && sortDir !== 'NONE' ? '1.2' : '1'}) rotateZ(${
              sortBy === 'id' && sortDir === 'ASC' ? '180deg' : '0deg'
            })`,
          }}
        >
          <ArrowDownIcon />
        </button>
      </div>
      <div className="payouts-list-header-element">
        <div>{t('payoutPage.payoutsList.header.dateTime')}</div>
        <button
          className="sort-by-button"
          onClick={() => onSort('date')}
          style={{
            opacity: sortBy === 'date' && sortDir !== 'NONE' ? 1 : 0.6,
            transform: `scale(${sortBy === 'date' && sortDir !== 'NONE' ? '1.2' : '1'}) rotateZ(${
              sortBy === 'date' && sortDir === 'ASC' ? '180deg' : '0deg'
            })`,
          }}
        >
          <ArrowDownIcon />
        </button>
      </div>
        <div className="payouts-list-header-element amount">
            <div>{t('payoutPage.payoutsList.header.amount')} (BTC)</div>
            <button className="sort-by-button" onClick={() => onSort('amount')}>
                <ArrowDownIcon />
            </button>
        </div>
      <div className="payouts-list-header-element txid">
        <div>{t('payoutPage.payoutsList.header.idTransaction')} (BTC)</div>
        <button
          className="sort-by-button"
          onClick={() => onSort('transactionId')}
          style={{
            opacity: sortBy === 'transactionId' && sortDir !== 'NONE' ? 1 : 0.6,
            transform: `scale(${
              sortBy === 'transactionId' && sortDir !== 'NONE' ? '1.2' : '1'
            }) rotateZ(${sortBy === 'transactionId' && sortDir === 'ASC' ? '180deg' : '0deg'})`,
          }}
        >
          <ArrowDownIcon />
        </button>
      </div>
      <div className="payouts-list-header-element confirmation">
        <div>{t('payoutPage.payoutsList.header.networkConfirmation')}</div>
        <button
          className="sort-by-button"
          onClick={() => onSort('confirmed')}
          style={{
            opacity: sortBy === 'confirmed' && sortDir !== 'NONE' ? 1 : 0.6,
            transform: `scale(${
              sortBy === 'confirmed' && sortDir !== 'NONE' ? '1.2' : '1'
            }) rotateZ(${sortBy === 'confirmed' && sortDir === 'ASC' ? '180deg' : '0deg'})`,
          }}
        >
          <ArrowDownIcon />
        </button>
      </div>
    </StyledPayoutListHeader>
  );
};
